import React from 'react';
import { TextField, InputAdornment } from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';

const TableSearchComponent = ({ 
  value, 
  onChange, 
  placeholder = "Search...", 
  fullWidth = true,
  columns = [], // Array of column names for search
  size = 'medium'
}) => {
  const getPlaceholder = () => {
    if (placeholder !== "Search...") return placeholder;
    if (columns.length > 0) {
      return `Search by ${columns.join(', ')}...`;
    }
    return "Search...";
  };

  return (
    <TextField
      fullWidth={fullWidth}
      placeholder={getPlaceholder()}
      value={value}
      onChange={onChange}
      size={size}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        ),
      }}
    />
  );
};

export default TableSearchComponent; 